module.exports = __webpack_public_path__ + "static/media/copy-packet1.7f4a898e.svg";